import { DialogType } from '@tableau/widgets';
import * as React from 'react';

import { CommonStyles } from '../../common/react/CommonStyles';
import { ModalInstance, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { AddLocalUsersDialog } from '../components/AddLocalUsersDialog';

const serverAndSiteUsersDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: CommonStyles.Sizes.LargeSpace,
  paddingBottom: CommonStyles.Sizes.MediumSpace,
  paddingLeft: CommonStyles.Sizes.MediumSpace,
  paddingRight: CommonStyles.Sizes.MediumSpace
};

export enum AddLocalUserDialogType {
  SERVER = 'server',
  SITE = 'site'
}

const localSiteAddUsersDialogTestId = 'localSiteAddUsersDialog';
const localServerAddUsersDialogTestId = 'localServerAddUsersDialog';

export class AddLocalUserAction {
  public static readonly instance = new AddLocalUserAction();

  public showAddLocalUserDialog(addLocalUserDialogType: AddLocalUserDialogType,
    availableQuota?: number): Promise<any> {

    let modalInstance: ModalInstance;
    const dialogProps = {
      dismiss: () => modalInstance && modalInstance.dismiss(),
      close: (result: any) => modalInstance && modalInstance.close(result),
      addLocalUserDialogType: addLocalUserDialogType,
      availableQuota: availableQuota,
    };

    modalInstance = ReactModalService.open({
      type: DialogType.Uber,
      dialogContent: React.createElement(AddLocalUsersDialog, dialogProps),
      testId: addLocalUserDialogType === AddLocalUserDialogType.SERVER ? localServerAddUsersDialogTestId : localSiteAddUsersDialogTestId,
      showCloseButton: true,
      dialogStyle: serverAndSiteUsersDialogStyle,
      shouldNotSetDefaultWidth: true
    });

    return modalInstance.result;
  }
}

export default AddLocalUserAction.instance;
